import { RequestParamsController } from "../../../common/scripts/request_params_controller";

export class RequestParamsMaker {
  /**
   * 在席の生データ取得処理用リクエストデータ
   * @param userID
   * @param deviceId
   * @param authStore
   */
  public static makeGetSeatDataParams(
    userID: string,
    deviceId: string,
    authStore: any
  ) {
    const data = {
      user_id: userID,
      device_id: deviceId,
      auth_store: authStore,
    };
    return RequestParamsController.create("post", "getSeatData", data);
  }

  /**
   * 在席 センサーデータの過去8時間履歴を取得処理用リクエストデータ生成処理。
   * @param {string} userID
   * @param authStore
   * @param {string} deviceId
   * @returns リクエストデータ
   */
  public static makeGetSeatHistory(
    userID: string,
    authStore: any,
    deviceId: string,
  ) {
    const data = {
      user_id: userID,
      auth_store: authStore,
      device_id: deviceId,
    };
    return RequestParamsController.create("post", "getSeatData", data);
    // return RequestParamsController.create("post", "getSeatHistory", data);
  }
}
